import { Box, Button, ExternalLinkIcon, Link, RefreshIcon } from '@razorpay/blade/components';
import { EmptyListView } from 'components/ui/EmptyListView/EmptyListView';
import { helpArticles } from '../constants';

interface ErrorStateProps {
  errorString: string | null;
  onRetry: () => void;
}

const SalaryStructuresListErrorStateView = ({
  errorString,
  onRetry,
}: ErrorStateProps) => {
  return (
    <EmptyListView
      title={`There was an error while fetching the data for salary structures.`}
      description={errorString ? errorString : null}>
      <Box display="flex" flexDirection="column" gap="spacing.4" marginX="auto">
        <Link
          size="medium"
          variant="anchor"
          href={helpArticles.learnMore}
          icon={ExternalLinkIcon}
          iconPosition="right"
          target="_blank">
          Learn more about salary structures
        </Link>
        <Box marginX="auto">
          <Button
            size="medium"
            onClick={onRetry}
            isFullWidth
            iconPosition="left"
            icon={RefreshIcon}>
            Retry
          </Button>
        </Box>
      </Box>
    </EmptyListView>
  );
};

export default SalaryStructuresListErrorStateView;
